import * as React from 'react';

import classnames from 'classnames';

import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {ArrowsAscIcon} from 'shells/icon/svg/arrows-asc-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ArrowsDescIcon} from 'shells/icon/svg/arrows-desc-icon';

import type {SortObject} from './template-list-group';

import styles from './templates.module.css';

type Props = {
    currentSort: SortObject;
    onColumnSort: (column: string) => void;
    showSorting: boolean;
};

export function TemplateListHeader(props: Props) {
    const {onColumnSort, currentSort, showSorting} = props;

    return (
        <React.Fragment>
            <tr className={styles['group-header']}>
                <TemplateListColumnHeader
                    columnName='name'
                    displayName='Name'
                    currentSort={currentSort}
                    groupTitle='Name'
                    onColumnSort={onColumnSort}
                    showSorting={showSorting}
                />
                <TemplateListColumnHeader
                    columnName='lastSentTime'
                    displayName='Last sent'
                    currentSort={currentSort}
                    onColumnSort={onColumnSort}
                    showSorting={showSorting}
                />
                <TemplateListColumnHeader
                    columnName='replyRate'
                    displayName='Reply %'
                    isRightAligned={true}
                    currentSort={currentSort}
                    onColumnSort={onColumnSort}
                    showSorting={showSorting}
                />
                <TemplateListColumnHeader
                    columnName='clickRate'
                    displayName='Click %'
                    isRightAligned={true}
                    currentSort={currentSort}
                    onColumnSort={onColumnSort}
                    showSorting={showSorting}
                />
                <th className={styles['action-column-header']} />
            </tr>
        </React.Fragment>
    );
}

type ColumnHeaderProps = {
    columnName: string;
    displayName: string;
    currentSort: SortObject;
    groupTitle?: string;
    isRightAligned?: boolean;
    onColumnSort: (column: string) => void;
    showSorting: boolean;
};

function TemplateListColumnHeader(props: ColumnHeaderProps) {
    const {columnName, groupTitle, currentSort} = props;
    const displayName = groupTitle ? groupTitle : props.displayName;

    const columnSorter = () => {
        props.onColumnSort(columnName);
    };

    const isColumnSorted = columnName === currentSort.columnName && props.showSorting;

    const sortIcon =
        currentSort.order === 'ascending' ? (
            <ArrowsAscIcon wrapWithDiv={false} size={15} fill={colors.blue} />
        ) : (
            <ArrowsDescIcon wrapWithDiv={false} size={15} fill={colors.blue} />
        );

    const styleNames = classnames({
        [styles['column-header']]: props.showSorting,
        [styles['column-header-no-sort']]: !props.showSorting,
        [styles['column-header-right-aligned']]: props.isRightAligned,
    });

    return (
        <th
            scope={groupTitle ? 'auto' : 'col'}
            role='columnheader'
            aria-sort={isColumnSorted ? currentSort.order : 'none'}
            className={styleNames}
        >
            <Button variant='text-secondary' size='xlarge' onClick={columnSorter}>
                <div className={styles['sort-button-contents']}>
                    {displayName}
                    <div>{isColumnSorted ? sortIcon : null}</div>
                </div>
            </Button>
        </th>
    );
}
